import React, { useState, useEffect } from "react";
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import 'primeicons/primeicons.css';

function InfoRelato({ setFraseTopo, setStage,
    infos, contribuicaoDPE, setInfos, setContribuicaoDPE, enviar_email }) {

    useEffect(() => {
        setFraseTopo("Existe vida após a violência.");
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className="app-main-mulher">
            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div style={{width:'100%'}}>
                        <p className="labels"><strong>Informações que você queira relatar e não foi perguntado</strong></p>
                        <InputTextarea rows={5} value={infos} placeholder="Sua resposta" onChange={(e) => setInfos(e.target.value)} />
                    </div>
                </div>
            </div>

            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div style={{width:'100%'}}>
                        <p className="labels"><strong>Como você acha que a Defensoria Pública pode contribuir para solucionar seu problema?</strong></p>
                        <InputTextarea rows={5} value={contribuicaoDPE} placeholder="Sua resposta" onChange={(e) => setContribuicaoDPE(e.target.value)} />
                    </div>
                </div>
            </div>

            <div className="card-rodape-mulher">
                <Button
                    label="Voltar"
                    className="btn-1-mulher"
                    onClick={() => setStage(5)}
                />
                <Button
                    style={{ marginLeft: "10px" }}
                    label="Finalizar"
                    className="btn-1-mulher"
                    onClick={() => {
                        enviar_email(7);
                    }}
                />
            </div>
        </div>

    );
}

export default InfoRelato;
